import * as moment from "moment";
import * as React from "react";
import { Control, Errors } from "react-redux-form";
import * as DTOS from "../../../../FeralScan.dtos";
import * as SurveyActionCreators from "../../../../actions/survey.actions";
import MonthYear from "./MonthYear";
import { mapProps, showErrors, updateOn } from "./ReactReduxFormSettings";
import ValidationMessage from "./ValidationMessage";
import { requiredDate } from "../../../Common/validators";

export type MonthYearControlProps = {
    attachment: any,
    selectClassName?: string,
    controlOrder: 'monthyear' | 'yearmonth',
    defaultDay: string,
    description: string,
    mandatory: boolean,
    model: string,
    name: string,
    questionIndex: number,
    readOnly: boolean,
    survey: DTOS.Survey
};

export type MonthYearControlActions = {
    setQuestionValue: typeof SurveyActionCreators.setQuestionValueRequest
};

export type MonthYearControlPropsAndActions = MonthYearControlProps & MonthYearControlActions;

class MonthYearControl extends React.PureComponent<MonthYearControlPropsAndActions, any> {
    constructor(props: MonthYearControlPropsAndActions) {
        super(props);
        this.props.setQuestionValue(this.props.questionIndex, `${this.props.defaultDay}/${moment(Date.now()).format("MM")}/${moment(Date.now()).format("YYYY")}`);
    }

    getMonth(date: string) {
        if (date) {
            try {
                let split: string[] = date.split('/');

                if (split.length == 3) {
                    return split[1];
                }
            }
            catch (e) {
                //there was an error
                console.log(e);
            }
        }

        return undefined;
    }

    getYear(date: string) {
        if (date) {
            try {
                let split: string[] = date.split('/');

                if (split.length == 3) {
                    return split[2];
                }
            }
            catch (e) {
                //there was an error
                console.log(e);
            }
        }

        return undefined;
    }

    render() {
        return (
            <div>
                <Control
                    component={MonthYear}
                    controlProps={{
                        className: this.props.selectClassName,
                        controlOrder: this.props.controlOrder,
                        defaultDay: this.props.defaultDay,
                        mandatory: this.props.mandatory,
                        month: this.getMonth(this.props.survey.questions[this.props.questionIndex].value),
                        name: this.props.name,
                        questionIndex: this.props.questionIndex,
                        year: this.getYear(this.props.survey.questions[this.props.questionIndex].value)
                    }}
                    mapProps={mapProps}
                    model={this.props.model}
                    readOnly={this.props.readOnly}
                    updateOn={updateOn}
                    validators={{
                        required: this.props.mandatory ? requiredDate : () => true
                    }}
                />
                <Errors
                    className="invalid-feedback d-block"
                    model={this.props.model}
                    messages={{
                        required: "Please select both a month and a year"
                    }}
                    show={showErrors}
                    component={ValidationMessage}
                />
                {this.props.description && this.props.description !== "" ? (
                    <p>{this.props.description}</p>
                ) : (
                        undefined
                    )}
                {this.props.attachment ? (
                    <img
                        alt={`${this.props.attachment.fileName}`}
                        src={`data:${this.props.attachment.fileType};base64,${this.props.attachment.data}`}
                        className=" img-checklist-item"
                    />
                ) : (
                        undefined
                    )}
                {
                    this.props.children
                }
            </div>
        );
    }
}

export default MonthYearControl;